var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.8,
    cy: 24.8,
    r: 24.8,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636363",
    fillRule: "nonzero",
    d: "M35.6 17.04a6.801 6.801 0 0 0 2.16-2.96c-1.111.53-2.3.881-3.52 1.04A5.76 5.76 0 0 0 24 18.72a6.81 6.81 0 0 0 .24 1.84c-8.56-.64-12-6.08-12-6.08s-2.08 4.32 1.28 7.76a3.76 3.76 0 0 1-1.92-.48s-.72 3.68 3.92 5.68a5.86 5.86 0 0 1-2 .16 6.24 6.24 0 0 0 5.28 4s-1.76 2.16-7.84 2.64a16.4 16.4 0 0 0 19.84-2.32s4.24-3.6 4.8-10.88l2.88-4.64-2.88.64z"
  }))));
};

export default SvgTwitter;